import React, { ChangeEvent, useState } from "react";
import classNames from "classnames";
import { isEmpty } from "lodash";

import { Button } from "components/Button/Button";
import { ImageBox } from "components/ImageBox/ImageBox";
import { ImageUploadBox } from "components/ImageUploadBox";

import styles from "./styles.module.css";
import { useUploadProductImage } from "./api";

const selectedStyles =
  "bg-purple-200 rounded transition duration-300 text-purple-500";

type Props = {
  onSetNewAddedImageLink: React.Dispatch<React.SetStateAction<string[]>>;
};

export const ProductPhotos = ({
  onSetNewAddedImageLink,
}: Props): JSX.Element => {
  const [selectedPhoto, setSelectedPhoto] = useState(null); // this is link
  const [uploadedImages, setUploadedImages] = useState<Array<any>>([]);

  const { mutate: uploadImage } = useUploadProductImage({});

  const handleUpload = (e: ChangeEvent<HTMLInputElement>) => {
    const image = e.target.files?.[0];

    if (image) {
      uploadImage(image, {
        onSuccess: (res) => {
          const link = res.data;

          setUploadedImages((prev) => [...prev, { name: image.name, link }]);
          onSetNewAddedImageLink((prev) => [...prev, link]);
        },
      });
    }
  };

  const handleRemove = () => {
    // TODO delete with request, because the file is already created in server
    if (!selectedPhoto) return;

    setUploadedImages((prev) => prev.filter((i) => i.link !== selectedPhoto));
    onSetNewAddedImageLink((prev) => prev.filter((i) => i !== selectedPhoto));
  };

  return (
    <div
      className={classNames(
        styles.productPhotosContainer,
        "productPhotosContainer flex flex-wrap py-4 px-4 mt-2 rounded-md overflow-y-scroll relative"
      )}
    >
      {!isEmpty(uploadedImages) &&
        uploadedImages.map((image) => (
          <ImageBox
            handleClick={() => setSelectedPhoto(image.link)}
            photo={image.link}
            className={`ml-3 cursor-pointer ${selectedPhoto === image.link && selectedStyles}`}
            height={160}
            width={160}
            text={image.name}
            key={image.name}
          />
        ))}
      <ImageUploadBox
        className="ml-3 cursor-pointer"
        onChange={handleUpload}
        height={160}
        width={160}
      />

      <Button
        icon="delete"
        onClick={handleRemove}
        className={styles.delete_button}
        disabled={!selectedPhoto}
      />
    </div>
  );
};
